export default __webpack_public_path__ + "static/media/generic-mobile.12685bec.png";